const KEY = "agentui_oauth_in_flight";
const TTL_MS = 10 * 60 * 1000;
const VALID = ["google", "microsoft", "sso"];

export function markOAuthFlight(method) {
    if (!VALID.includes(method)) return;
    try {
        sessionStorage.setItem(
            KEY,
            JSON.stringify({ method, ts: Date.now() })
        );
    } catch {
        // sessionStorage unavailable — silently skip
    }
}

export function consumeOAuthFlight() {
    let raw;
    try {
        raw = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
    } catch {
        return null;
    }
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!VALID.includes(parsed.method)) return null;
        if (typeof parsed.ts !== "number") return null;
        if (Date.now() - parsed.ts > TTL_MS) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function clearOAuthFlight() {
    try {
        sessionStorage.removeItem(KEY);
    } catch {
        // ignore
    }
}
